/**
 * @flow
 * @relayHash 3c72ded9531dd12903a4083c42cf5b04
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ShopDetailsHeaderQueryVariables = {|
  vendorID: string
|};
export type ShopDetailsHeaderQueryResponse = {|
  +shop: ?{|
    +id: string,
    +ref_id: string,
    +name: ?string,
    +avg_rating: ?number,
    +banner_url: ?string,
    +follow: ?boolean,
    +logo_url: ?string,
    +rating_count: ?number,
    +branches: ?$ReadOnlyArray<?{|
      +address: ?string,
      +city: string,
      +country: string,
      +headquarter: ?boolean,
      +first_phone_number: ?string,
      +first_phone_number_code: ?string,
      +id: string,
      +second_phone_number: ?string,
      +second_phone_number_code: ?string,
      +lat: ?number,
      +lng: ?number,
      +inwani_building: ?number,
      +inwani_street: ?number,
      +inwani_zone: ?number,
      +landline: ?string,
      +landline_code: ?string,
    |}>,
  |}
|};
export type ShopDetailsHeaderQuery = {|
  variables: ShopDetailsHeaderQueryVariables,
  response: ShopDetailsHeaderQueryResponse,
|};
*/


/*
query ShopDetailsHeaderQuery(
  $vendorID: ID!
) {
  shop(id: $vendorID) {
    id
    ref_id
    name
    avg_rating
    banner_url
    follow
    logo_url
    rating_count
    branches {
      address
      city
      country
      headquarter
      first_phone_number
      first_phone_number_code
      id
      second_phone_number
      second_phone_number_code
      lat
      lng
      inwani_building
      inwani_street
      inwani_zone
      landline
      landline_code
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "vendorID",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "shop",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "vendorID",
        "type": "ID!"
      }
    ],
    "concreteType": "Shop",
    "plural": false,
    "selections": [
      v1,
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "ref_id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "avg_rating",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "banner_url",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "follow",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "logo_url",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "rating_count",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "branches",
        "storageKey": null,
        "args": null,
        "concreteType": "VendorBranch",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "second_phone_number_code",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "address",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "country",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "headquarter",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "first_phone_number",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "first_phone_number_code",
            "args": null,
            "storageKey": null
          },
          v1,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "second_phone_number",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "city",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "lat",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "lng",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "inwani_building",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "inwani_street",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "inwani_zone",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "landline",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "landline_code",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "ShopDetailsHeaderQuery",
  "id": null,
  "text": "query ShopDetailsHeaderQuery(\n  $vendorID: ID!\n) {\n  shop(id: $vendorID) {\n    id\n    ref_id\n    name\n    avg_rating\n    banner_url\n    follow\n    logo_url\n    rating_count\n    branches {\n      address\n      city\n      country\n      headquarter\n      first_phone_number\n      first_phone_number_code\n      id\n      second_phone_number\n      second_phone_number_code\n      lat\n      lng\n      inwani_building\n      inwani_street\n      inwani_zone\n      landline\n      landline_code\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ShopDetailsHeaderQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v2
  },
  "operation": {
    "kind": "Operation",
    "name": "ShopDetailsHeaderQuery",
    "argumentDefinitions": v0,
    "selections": v2
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd04c00784e15de281f53f7dfac6c5f1f';
module.exports = node;
